module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Laeufelfingen-cdfe1e9e4294eea5e791bad4388e4222.png";